import ReportLayout from '@/modules/reports/layout/ReportLayout.vue';

const routes = [
  {
    path: 'landing-page',
    name: 'landing-page',
    component: () => import('@/modules/reports/views/LandingPage.vue')
  },
  {
    path: 'delinquency',
    name: 'delinquency',
    component: () => import('@/modules/reports/views/Delinquency.vue')
  },
  {
    path: 'loan',
    name: 'loan',
    component: () => import('@/modules/reports/views/Loan.vue')
  },
  {
    path: 'aml',
    name: 'aml',
    component: () => import('@/modules/reports/views/AML.vue')
  }
];

export default {
  path: 'general-reports',
  name: 'general-reports',
  component: ReportLayout,
  redirect: {
    name: 'landing-page'
  },
  meta: {
    requiresAuth: true
  },
  children: [...routes]
};
